import { MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  InputLabel,
  Stack,
} from '@legacy/components/mui-components';
import { stringToPascal } from '@legacy/utils/string';
import { translationAnyText } from '@legacy/utils/translation';
import {
  IViewOptionsField,
  ViewOptionsChangeParameters,
} from '../../../../types';

interface ResourceViewOptionsProps {
  viewOptionsFields?: Array<IViewOptionsField>;
  viewOptionsChange?: (item: ViewOptionsChangeParameters[]) => void;
}

export const ViewOptions = ({
  viewOptionsFields,
  viewOptionsChange,
}: ResourceViewOptionsProps) => {
  const { t } = useTranslation('viewOptions');
  const handleSelectChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    viewOptionsChange?.([{ name, value }]);
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      alignItems="bottom"
      flexWrap="wrap"
    >
      {viewOptionsFields && viewOptionsFields.length > 0 && (
        <Stack direction="row" flexWrap="wrap" gap={2}>
          {viewOptionsFields?.map(
            ({ name: fieldName, value: fieldValue, options }) => (
              <FormControl key={fieldName} size="small">
                <InputLabel id={`${fieldName}-label`}>
                  {translationAnyText(
                    t,
                    `FieldOption${stringToPascal(fieldName)}Label`,
                  )}
                </InputLabel>
                <Select
                  labelId={`${fieldName}-label`}
                  name={fieldName}
                  label={translationAnyText(
                    t,
                    `FieldOption${stringToPascal(fieldName)}Label`,
                  )}
                  value={fieldValue}
                  onChange={(e) => {
                    handleSelectChange(e);
                  }}
                  data-automation-id={`ViewOptions${stringToPascal(fieldName)}`}
                >
                  {options?.map(({ value }) => {
                    const label = translationAnyText(
                      t,
                      `FieldOption${stringToPascal(value)}`,
                    );

                    return (
                      <MenuItem key={value} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ),
          )}
        </Stack>
      )}
    </Stack>
  );
};
